var kigou = ""
// +
//"!\"#$%&'()\*\+\-\.,\/:;<=>?@\[\\\]^_`{|}~" +
//"①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮⑯⑰⑱⑲⑳" +
//"ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ" +
//"㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻" +
//"㎜㎝㎞㎎㎏㏄㎡〝〟№㏍℡㊤㊥㊦㊧㊨㈱㈲㈹㍻㍾㍽㍼" +
//"≒≡∫∮∑√⊥∠∟⊿∵∩∪" +
//"、。，．・：；？！゛゜´｀¨＾￣" +
//"＿ヽヾゝゞ〃仝々〆〇―‐／＼～∥｜…‥‘’“”" +
//"（）〔〕［］｛｝〈〉《》「」『』【】" +
//"＋－±×÷＝≠＜＞≦≧" +
//"∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§" +
//"☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓" +
//"∈∋⊆⊇⊂⊃∪∩∧∨￢⇒⇔∀∃∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬Å‰♯♭♪" +
//"ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ" +
//"αβγδεζηθικλμνξοπρστυφχψω" +
//"АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ" +
//"абвгдеёжзийклмнопрстуфхцчшщъыьэюя" +
//"─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂"
;

export const KIGOU = kigou;

export const APPLY_PROGRESS = 1;
export const APPLY_BACK = 2;
export const APPROVAL_FINISH = 3;
export const APPLY_NOT = 4;
export const APPROVAL_PROGRESS = 5;

export const MAX_CODE_DEFAULT = 999999;
export const MIN_CODE_DEFAULT = 1;

// 全画面共通の定数定義
export const COMMON_CONSTANT = Object.freeze({
	NO_SELECT: -2,			// 指定なし
	NO_INSTRUCTION: -2,		// 指示なし
	TERM_SEND_ALWAYS: -2,	// 配信期間なし
	MODEL_DEPENDENT: -1,	// はかり優先
	SUPERIOR: -1,			// 上位参照
	NO_SETTING: 0			// 設定なし
});

// 修正ここから
// 画面URL
export const DISPLAY_URL = Object.freeze({
	DIGI_ACCOUNT: 'digi_account',			// DIGIアカウント
	SELLER_ACCOUNT: 'seller_account',		// 管理会社アカウント
	DEALER_ACCOUNT: 'dealer_account',		// ディーラーアカウント
});
// ユーザータイプ
export const USER_TYPE = Object.freeze({
	DIGI: 0,		// ユーザータイプ(DIGI)
	SELLER: 1,		// ユーザータイプ(管理会社)
	DEALER: 2,		// ユーザータイプ(ディーラー)
});
// ここまで

// アップデートタイプ
export const UPDATE_TYPE = Object.freeze({
	UPDATE_TYPE_ADD: 0,		// 新規
	UPDATE_TYPE_UP: 1,		// 更新
	UPDATE_TYPE_DEL: 2,		// 削除
	UPDATE_TYPE_OTHER: 3,	// マスターごとの独自処理
	URL_NAME: 'update'
});

export const LIST_BASE = Object.freeze({
	INITIAL_SORT_ID: 1,
	INITIAL_PAGE_NO: 1,
	RESULT_NUM: 1000
});

export const TEXT_CL = Object.freeze({
	GRP0: 2,	 // グループ
	STR0: 3,	 // 店舗
	ING0: 4,	 // 添加物
	SPM0: 5,	 // スペシャルメッセージ
	CMM0: 6,	 // 広告文
	SHP0: 7,	 // 店名
	TMP0: 8,	 // 保存温度
	CMT0: 9,	 // コメント
	URL0: 10,	 // URL
	NUT2: 11,	 // 栄養成分名称
	NUT3: 12,	 // 栄養成分単位
	PLS0: 13,	 // 産地
	ALG0: 14,	 // アレルギー物質
	DEP0: 15,	 // ライン
	CLS2: 19,	 // 大分類
	CLS1: 20,	 // 中分類
	CLS0: 21,	 // 小分類
	SYM0: 22,	 // 内容量単位
	SPM2: 23,	 // スペシャルメッセージ2
	SPM3: 24,	 // スペシャルメッセージ3
	BBS0: 25,	 // ブラウザブックマーク
	PLU0: 100,	 // 商品
	PSB0: 101,	 // 商品サブコード
	IML3: 102,	 // POPイメージ
	IML5: 103,	 // 商品イメージ
	MTP0: 104,	 // 原料生産地
	MTR0: 105,	 // 原料
	TAX0: 106,	 // 税金
	TAX1: 107,	 // 税金スペック
	FML6: 108,	 // フォーマット
	NUT4: 109,	 // 栄養成分構成
	NUT1: 110,	 // 栄養成分表
	PPN0: 111,	 // 商品プリセットページ名称
	PPS0: 112,	 // 商品プリセット
	PPN3: 113,	 // グループプリセットページ名称
	PPS3: 114,	 // グループプリセット
	TRY1: 115,	 // トレー
	MPG : 117,	 // 動画
	RUP0: 118,	 // 商品事前設定
	IML4: 119,	 // 事前設定イメージリンクラベルサイズ
	MJS0: 120,	 // 製造作業指示予約
	PPS1: 122,	 // 商品プリセット（SM4600/DPR-460）
	PPS2: 123,	 // 商品プリセット（SM5600）
	JBS0: 124,	 // 作業指示予約
	POT0: 125,	 // Pack on Time商品設定
	POT1: 126,	 // Pack on Timeパターン設定
	POT2: 127,	 // Pack on Time時間帯指定
	PPS4: 128,	 // 商品プリセット（SM4600/DPR-460）
	PPS5: 130,	 // 商品プリセット（SM5600）
	PRT0: 202, // 部位
	GRD0: 203, // 等級
	BRD0: 204, // 品種
	LST0: 205, // 畜種
	SPR0: 206, // スキャン用部位
	STM0: 207, // 仕入先
	CMT2_CSV: 2001,	 // コメント（CMT2）CSV
	CMT0_CSV: 2015,	 // コメント（CMT0）CSV
	PRTT: 2017, // 部位（PRTT）
	GRDT: 2019, // 等級（GRDT）
	BRDT: 2021, // 品種（BRDT）
	LSTT: 2023, // 畜種（LSTT）
	PLST: 2026, // 産地（PLST）
	TMPT: 2027, // 保存温度（TMPT）
	CMTT: 2028, // コメント（CMTT）
	URLT: 2029, // URLコメント（URLT）
	MEST: 2030, // メッセージ（MEST）

	// マスター削除で使用
	PLU0_RES: -1,	 // 商品予約
	ING0_RES: -2,	 // 添加物予約
	SPM0_RES: -3,	 // スペシャルメッセージ予約
	SPM2_RES: -4,	 // スペシャルメッセージ2予約
	SPM3_RES: -5,	 // スペシャルメッセージ3予約
	PLS0_RES: -6,	 // 産地予約
	CMM0_RES: -7,	 // 広告文予約
	TMP0_RES: -8,	 // 保存温度予約
	CMT0_RES: -9,	 // コメント予約
	URL0_RES: -10,	 // URL予約
	SHP0_RES: -11,	 // 店名予約
	PLU0_APP: -101,	 // 商品申請
	ING0_APP: -102,	 // 添加物申請
	SPM0_APP: -103,	 // スペシャルメッセージ申請
	SPM2_APP: -104,	 // スペシャルメッセージ2申請
	SPM3_APP: -105,	 // スペシャルメッセージ3申請
	PLS0_APP: -106,	 // 産地申請
	CMM0_APP: -107,	 // 広告文申請
	TMP0_APP: -108,	 // 保存温度申請
	CMT0_APP: -109,	 // コメント申請
	URL0_APP: -110,	 // URL申請
});

export const PLU_LINK_BIT = Object.freeze({
	NO: 0b0000,
	SPM0: 0b0001,
	SPM2: 0b0010,
	SPM3: 0b0100,
	ING0: 0b1000,
});

export const TAX_CODE_SETTING_CL = Object.freeze({
	NOSETTING_DISABLED: 0,		// [0：設定なし]設定不可
	FREE_DISABLED: 1,			// [10：非課税]設定不可
	NOSETTING_FREE_DISABLED: 2,	// [0：設定なし]、[10：非課税]設定不可
	NOSETTING_FREE_ENABLED: 3	// [0：設定なし]、[10：非課税]設定可
});


// WEBPACK FOOTER //
// ./resources/assets/js/const/constants.js